<div class="card email-settings-page settings-page">
  <div class="card-body">
    @if (isLoading()) {
      <app-loader [minHeight]="100" />
    } @else if (emailSettingsData && emailSettingsData.from) {
        <div class="no-templates-message">
          <div>Emails will be sent from your custom address: <a [href]="'mailto:' + emailSettingsData.from">{{ emailSettingsData.from }}</a>.</div>
          <div>If you’d like to make changes, please contact support.</div>
        </div>
    } @else {
      <div class="no-templates-message">
        Pravo default email address (<a [href]="'mailto:' + boltEmailAddress">{{ boltEmailAddress }}</a>) will be used
        for sending emails. If you would like to add a custom email, please contact support.
      </div>
    }
  </div>
</div>
